import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './home/dashboard.component';
import { CompaniesCallbackComponent } from './home/companiescall.component';
import { DashboardCallbackComponent } from './home/dashboardcall.component';

import { OldCustomerCompanyCreateComponent } from './customers/create/company/old-version/old-customer-create.component';
import { CustomerDetailComponent } from './customers/customerdetail.component';
import { CustomerEditComponent } from './customers/customeredit.component';
import { CustomerImportComponent } from './customers/customerimport.component';
import { CustomerCorporateListController } from './customers/customer-list/coporate/controller/controller.component';
import { CompaniesListComponent } from './customers/companieslist.component';
import { CustomerCompanyListController } from './customers/customer-list/company/controller/controller.component';
import { PaymentCustomerImportComponent } from './customers/paymentcustomerimport.component';
import { newpaymentcustomerimport } from './customers/customer-list/customer-import-new/newpaymentcustomerimport.component';

import { InvoiceCreateComponent } from './invoices/components/create/old-version/invoicecreate.component';
import { InvoiceImportComponent } from './invoices/invoiceimport.component';
import { PaymentInvoiceImportComponent } from './invoices/paymentinvoiceimport.component';

import { InvoicesCorporateListController } from './invoices/corporate/list/controller/controller.component';
import { CorporateInvoiceViewComponent } from './invoices/corporate/view/view.component';

import { CollectInvoiceListComponent } from './invoices/collect/list/list.component';
import { CollectInvoiceViewComponent } from './invoices/collect/view/view.component';
import { CollectInvoiceEditComponent } from './invoices/collect/edit/edit.component';

import { InvoicesPaymentListController } from './invoices/payment/list/controller/controller.component';
import { PaymentInvoiceViewComponent } from './invoices/payment/view/view.component';
import { PaymentInvoiceEditComponent } from './invoices/payment/edit/edit.component';

import { PayoutInvoiceListComponent } from './invoices/payout/list/list.component';
import { PayoutInvoiceViewComponent } from './invoices/payout/view/view.component';

import { PaymentListComponent } from './payments/paymentlist.component';
import { PaymentDetailComponent } from './payments/paymentdetail.component';
import { PaymentCreateComponent } from './payments/paymentcreate.component';
import { PaymentEditComponent } from './payments/paymentedit.component';

import { AccountsListComponent } from './accounts/accountslist.component';
import { AccountsOperationBankComponent } from './accounts/accountoperationbank.component';
import { AccountsOperationPspComponent } from './accounts/accountoperationpsp.component';
import { AccountsOperationVirtualComponent } from './accounts/accountoperationvirtual.component';
import { AccountCreateComponent } from './accounts/accountcreate.component';
import { AccountsOperationSettlementComponent } from './accounts/accountoperationsettlement.component';
import { AccountsOperationCollectComponent } from './accounts/accountoperationcollect.component';
import { AccountsOperationBankCategorizeComponent } from './accounts/accountoperationbankcategorize.component';
import { AccountOperationbankImport } from './accounts/accountoperationbankimport.component';
import { AccountsOperationPspDetailComponent } from './accounts/accountoperationpspdetail.component';

import { SettlementListComponent } from './accounts/settlementlist.component';
import { SettlementDetailComponent } from './accounts/settlementdetail.component';

import { PaymentListReportComponent } from './reports/paymentlistreport.component';
import { SettlementCorporateListComponent } from './reports/settlementcorporatelist.component';
import { PaymentCorporateListReportComponent } from './reports/paymentcorporatelist.component';


import { ErrorComponent } from './home/error.component';
import { LogoutComponent } from './login/logout.component';
import { CallbackComponent } from './login/callback.component';
import { ForgotPwdComponent } from './login/forgot-password/forgotpassword.component';

import { LayoutComponent } from './settings/layout/layout.component';
import { ProfileController } from './settings/profile/controller/controller.component';
import { TemplateListComponent } from './settings/templatelist.component';
import { AuthGuardService as AuthGuard } from './_services/auth-guard.service';
import { TemplateCreateComponent } from './settings/templatecreate.component';
import { TemplateEditComponent } from './settings/templateedit.component';
import { ConfigurationMenuComponent } from './settings/configurationmenu.component';
import { NotificationListComponent } from './settings/notificationlist.component';

import { SalesInvoiceCreateComponent } from './sales/salesinvoicecreate.component';

import { SalesInvoicesListComponent } from './sales/salesinvoicelist.component';

import { SalesInvoiceDetailComponent } from './sales/salesinvoicedetail.component';

import { SalesInvoiceEditComponent } from './sales/salesinvoiceedit.component';

import { ApiComponent } from './settings/api.component';
import { WebhookComponent } from './settings/webhook.component';

import { OldUserListComponent } from './settings/users/list/old-version/old-user-list.component';

import { BatchListController } from './processes/batch-list/controller/controller.component';
import { NewProcessImportComponent } from './processes/process-import/new-process-import/new-process-import.component';

import { EventsComponent } from './settings/events/old-version/events.component';

import { NotificationReportListComponent } from './reports/notificationreportlist.component';

import { PayoutProcessListComponent } from './payout_process/payoutprocesslist.component';
import { NewPayoutprocessImportComponent } from './payout_process/payout-import-process/new-payout-import-version/new-payoutprocess-import.component';

import { AccountOperationPayoutComponent } from './accounts/accountoperationpayout.component';

import { PayoutProcessViewComponent } from './payout_process/payoutprocessview.component';
import { AppComponent } from './app.component';
import { PayoutprocessCommerceComponent } from './payout_process/payoutprocesscommerce/payoutprocesscommerce.component';
import { PayoutprocesscommerceviewComponent } from './payout_process/payoutprocesscommerceview/payoutprocesscommerceview.component';
import { PayoutprocesscommerceconfirmComponent } from './payout_process/payoutprocesscommerceconfirm/payoutprocesscommerceconfirm.component';
import { CorporateInvoiceEditComponent } from './invoices/corporate/edit/edit.component';

import { VersionComponent } from './sharedcomp/version/version.component';
import { PayoutProcessCommerceMasiveConfirmComponent } from './payout_process/payout-process-commerce-masive-confirm/payout-process-commerce-masive-confirm.component';
import { PayoutCommerceGuard } from './_guards/payout-commerce.guard';
import { NewProcessImportCustomerComponent } from './customers/customer-list/customer-import-new/new-process-import-customer.component';

const appRoutes: Routes = [
  { path: '', redirectTo: 'loading', pathMatch: 'full' },
  { path: 'version', component: VersionComponent },
  { path: 'loading', component: AppComponent },
  { path: 'home', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'dashboard/:id', component: DashboardComponent, canActivate: [AuthGuard] },

  { path: 'customers', component: CustomerCompanyListController, canActivate: [AuthGuard] },
  { path: 'customers/corporatelist', component: CustomerCorporateListController, canActivate: [AuthGuard] },

  { path: 'customers/create', component: OldCustomerCompanyCreateComponent, canActivate: [AuthGuard] },
  { path: 'customers/:id/edit', component: CustomerEditComponent, canActivate: [AuthGuard] },
  { path: 'customers/:id/view', component: CustomerDetailComponent, canActivate: [AuthGuard] },

  { path: 'customers/import', component: CustomerImportComponent, canActivate: [AuthGuard] },
  { path: 'customers/payment/import', component: PaymentCustomerImportComponent, canActivate: [AuthGuard] },
  // { path: 'customers/payment/import', component: newpaymentcustomerimport, canActivate: [AuthGuard] },
  { path: 'customers/payment/imports', component: NewProcessImportCustomerComponent, canActivate: [AuthGuard] },


  { path: 'companies', component: CompaniesListComponent, canActivate: [AuthGuard] },

  { path: 'invoices/create', component: InvoiceCreateComponent, canActivate: [AuthGuard] },
  { path: 'invoices/import', component: InvoiceImportComponent, canActivate: [AuthGuard] },
  { path: 'invoices/payment/import', component: PaymentInvoiceImportComponent, canActivate:[AuthGuard]},

  { path: 'corporate/invoices', component: InvoicesCorporateListController, canActivate: [AuthGuard] },
  { path: 'corporate/invoices/:id/view', component: CorporateInvoiceViewComponent, canActivate: [AuthGuard] },
  { path: 'corporate/invoices/:id/edit', component: CorporateInvoiceEditComponent, canActivate: [AuthGuard] },

  { path: 'collect/invoices', component: CollectInvoiceListComponent, canActivate: [AuthGuard] },
  { path: 'collect/invoices/:id/view', component: CollectInvoiceViewComponent, canActivate: [AuthGuard] },
  { path: 'collect/invoices/:id/edit', component: CollectInvoiceEditComponent, canActivate: [AuthGuard] },

  { path: 'payments/invoices', component: InvoicesPaymentListController, canActivate: [AuthGuard] },
  { path: 'payments/invoices/:id/view', component: PaymentInvoiceViewComponent, canActivate: [AuthGuard] },
  { path: 'payments/invoices/:id/edit', component: PaymentInvoiceEditComponent, canActivate: [AuthGuard] },

  { path: 'payout/invoices', component: PayoutInvoiceListComponent, canActivate: [AuthGuard] },
  { path: 'payout/invoices/:id/view', component: PayoutInvoiceViewComponent, canActivate: [AuthGuard] },

  { path: 'payments', component: PaymentListComponent, canActivate: [AuthGuard] },
  { path: 'payments/create', component: PaymentCreateComponent, canActivate: [AuthGuard] },
  { path: 'payments/:id/edit', component: PaymentEditComponent, canActivate: [AuthGuard] },
  { path: 'payments/:id/view', component: PaymentDetailComponent, canActivate: [AuthGuard] },

  { path: 'accounts', component: AccountsListComponent, canActivate: [AuthGuard] },
  { path: 'accounts/bank/:id/operations', component: AccountsOperationBankComponent, canActivate: [AuthGuard] },
  { path: 'accounts/psp/:id/operations', component: AccountsOperationPspComponent, canActivate: [AuthGuard] },
  { path: 'accounts/virtual/:id/operations', component: AccountsOperationVirtualComponent, canActivate: [AuthGuard] },
  { path: 'accounts/create', component: AccountCreateComponent, canActivate: [AuthGuard] },
  { path: 'accounts/settlement/:id/operations', component: AccountsOperationSettlementComponent, canActivate: [AuthGuard] },
  { path: 'accounts/collect/:id/operations', component: AccountsOperationCollectComponent, canActivate: [AuthGuard] },
  { path: 'accounts/bank/:id/import', component: AccountOperationbankImport, canActivate: [AuthGuard] },
  { path: 'accounts/bank/:id/operations/:idc/:pageIndexDynamic', component: AccountsOperationBankCategorizeComponent, canActivate: [AuthGuard] },
  { path: 'psp/:id/view', component: AccountsOperationPspDetailComponent, canActivate: [AuthGuard] },
  { path: 'accounts/payout/:id/operations', component: AccountOperationPayoutComponent, canActivate: [AuthGuard] },


  { path: 'settlements', component: SettlementListComponent, canActivate: [AuthGuard] },
  { path: 'settlements/:id/view', component: SettlementDetailComponent, canActivate: [AuthGuard] },

  { path: 'reports/payments', component: PaymentListReportComponent, canActivate: [AuthGuard] },
  { path: 'corporate/settlements', component: SettlementCorporateListComponent, canActivate: [AuthGuard] },
  { path: 'corporate/payments', component: PaymentCorporateListReportComponent, canActivate: [AuthGuard] },


  { path: 'new_configuration_layout', component: LayoutComponent, canActivate: [AuthGuard] },
  { path: 'settings/profile', component: ProfileController, canActivate: [AuthGuard] },
  { path: 'templates/list', component: TemplateListComponent, canActivate: [AuthGuard] },
  { path: 'templates/create', component: TemplateCreateComponent, canActivate: [AuthGuard] },
  { path: 'templates/:id/edit', component: TemplateEditComponent, canActivate: [AuthGuard] },
  { path: 'configuration', component: ConfigurationMenuComponent, canActivate: [AuthGuard] },
  { path: 'notification/list', component: NotificationListComponent, canActivate: [AuthGuard] },
  { path: 'forgot_password', component: ForgotPwdComponent },
  { path: 'processes/batches', component: BatchListController, canActivate: [AuthGuard] },
  { path: 'processes/processimport', component: NewProcessImportComponent, canActivate: [AuthGuard] },

  { path: 'payout_process/list', component: PayoutProcessListComponent, canActivate: [AuthGuard] },
  { path: 'payout_process/:id/view', component: PayoutProcessViewComponent, canActivate: [AuthGuard] },
  { path: 'payout_process/payoutprocessimport', component: NewPayoutprocessImportComponent, canActivate: [AuthGuard] },

  { path: 'payout_process_commerce/list', component: PayoutprocessCommerceComponent, canActivate: [AuthGuard, PayoutCommerceGuard] },
  { path: 'payout_process_commerce/:id/view', component: PayoutprocesscommerceviewComponent, canActivate: [AuthGuard] },
  { path: 'payout_process_commerce/confirm/:customerID/:payoutID', component: PayoutprocesscommerceconfirmComponent, canActivate: [AuthGuard] },
  { path: 'payout_process_commerce/masive-confirm', component: PayoutProcessCommerceMasiveConfirmComponent, canActivate: [AuthGuard] },

  { path: 'settings/api', component: ApiComponent, canActivate: [AuthGuard] },
  { path: 'settings/webhook', component: WebhookComponent, canActivate: [AuthGuard] },
  { path: 'settings/userlist', component: OldUserListComponent, canActivate: [AuthGuard] },
  { path: 'sales/create', component: SalesInvoiceCreateComponent, canActivate: [AuthGuard] },
  { path: 'sales', component: SalesInvoicesListComponent, canActivate: [AuthGuard] },
  { path: 'sales/:id/view', component: SalesInvoiceDetailComponent, canActivate: [AuthGuard] },
  { path: 'sales/:id/edit', component: SalesInvoiceEditComponent, canActivate: [AuthGuard] },
  { path: 'error', component: ErrorComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'callback', component: CallbackComponent },
  { path: 'companiescallback', component: CompaniesCallbackComponent, canActivate: [AuthGuard] },
  { path: 'dashboardcallback', component: DashboardCallbackComponent, canActivate: [AuthGuard] },
  { path: 'settings/events', component: EventsComponent, canActivate: [AuthGuard] },
  { path: 'reports/notificationlist', component: NotificationReportListComponent, canActivate: [AuthGuard] },
  { path: 'corporate/reports/notificationlist', component: NotificationReportListComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: 'loading' }
];

export const routing = RouterModule.forRoot(appRoutes, { useHash: false, scrollPositionRestoration: 'enabled' });
